Drupal.behaviors.klaroConsentsToDataLayer = {
  attach: function(context, settings) {
    var gtmLoaded = false;
    
    function loadGTMScript() {
      if (gtmLoaded) return;
      
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window, document, 'script', 'dataLayer', 'GTM-KX8X6CLH');
      
      gtmLoaded = true;
    }

    function handleConsentChange(consents) {
      // Load GTM script if statistic or marketing consent is granted
      if (consents && (consents['statistic'] || consents['marketing'])) {
        loadGTMScript();
      }

      if (consents) {
        gtag('consent', 'update', {
          analytics_storage: consents['statistic'] ? 'granted' : 'denied',
          ad_storage: consents['marketing'] ? 'granted' : 'denied',
          ad_user_data: consents['marketing'] ? 'granted' : 'denied',
          ad_personalization: consents['marketing'] ? 'granted' : 'denied',
          functionality_storage: consents['third_party_services'] ? 'granted' : 'denied',
          personalization_storage: consents['third_party_services'] ? 'granted' : 'denied',
          security_storage: 'granted'
        });
      }
    }

    function getKlaroConsent() {
      var match = document.cookie.match(/klaro=([^;]+)/);
      if (match) {
        try {
          return JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
          console.warn('Could not parse Klaro cookie:', e);
        }
      }
      return null;
    }

    // Initialize and start polling immediately
    var lastConsent = null;
    
    function pollForChanges() {
      var currentConsent = getKlaroConsent();
      var currentConsentString = JSON.stringify(currentConsent);
      var lastConsentString = JSON.stringify(lastConsent);
      
      if (currentConsentString !== lastConsentString) {
        console.log('Consent changed from', lastConsent, 'to', currentConsent);
        
        // Call handleConsentChange on any change
        handleConsentChange(currentConsent);
        
        // Update dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'klaro_consent_update',
          'klaro_consents': currentConsent
        });
        
        lastConsent = currentConsent;
      }
    }
    
    // Check for existing consent on load and handle it
    var existingConsent = getKlaroConsent();
    if (existingConsent) {
      handleConsentChange(existingConsent);
      lastConsent = existingConsent;
    }
    
    // Check immediately on load
    pollForChanges();
    
    // Poll every 500ms for changes
    setInterval(pollForChanges, 500);
  }
};